import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConstantsFordProtect } from "src/app/models/constants/constants-ford-protect";
import { ApsPermissionService } from "../aps-permission/aps-permission.service";

@Injectable({
	providedIn: 'root'
})
export class SystemCountryService {

	private userCountry!: string;
	private readonly supportedCountries = new Set([
		ConstantsFordProtect.ARG,
		ConstantsFordProtect.BRA,
		ConstantsFordProtect.CHL,
		ConstantsFordProtect.COL,
		ConstantsFordProtect.VEN,
	]);

	constructor(private httpClient: HttpClient,
		private apsPermissionService: ApsPermissionService) {
	}

	setSystemCountry() {
		this.userCountry = this.resolveSystemCountry();
	}

	getSystemCountry(): string {
		const resolvedCountry = this.resolveSystemCountry();

		if (resolvedCountry !== this.userCountry) {
			this.userCountry = resolvedCountry;
		}

		return this.userCountry;
	}

	private resolveSystemCountry(): string {

		const selectedCountry = this.normalizeCountry(sessionStorage.getItem(ConstantsFordProtect.SYSTEM_COUNTRY));
		if (this.isSupportedCountry(selectedCountry)) {

			console.log(`Selected country from session storage is supported: ${selectedCountry}`);
			return selectedCountry;
		}

		if (selectedCountry) {
			sessionStorage.removeItem(ConstantsFordProtect.SYSTEM_COUNTRY);
		}

		const userCountry = this.normalizeCountry(this.apsPermissionService.getUserCountry());
		if (this.isSupportedCountry(userCountry)) {
			sessionStorage.setItem(ConstantsFordProtect.SYSTEM_COUNTRY, userCountry);
			return userCountry;
		}

		return '';
	}

	private normalizeCountry(country: string | null | undefined): string {
		return (country || '').trim().toUpperCase();
	}

	private isSupportedCountry(country: string): boolean {
		return this.supportedCountries.has(country);
	}

}
